@if (_accessService.validarPermisoSlug('MARKS-CRUD-MODAL')) {
<div class="flex flex-row gap-4 items-center">
  <div
    class="flex rounded-full px-2 py-0.5 gap-4 justify-between transition-opacity duration-300 bg-mg-green cursor-pointer text-mg-green-dark"
    [ngClass]="{
          'bg-mg-gray-light cursor-not-allowed text-mg-gray-dark opacity-50': redButtonExist || isIntervalDisabled,
        }" (click)="!isIntervalDisabled && !redButtonExist && toggleTimer()"
    [matTooltip]="isIntervalDisabled && errorData.message ? errorData.message : ''" matTooltipPosition="above"
    matTooltipShowDelay="300">
    <div class="justify-center items-center flex gap-3 font-semibold font-dmsans text-lg ml-2">
      @if(hasStartedOnce){
      <p class="w-[80px]">{{ formattedTime }}</p>
      <p>|</p>
      }
      <p>{{ currentInterval.label }}</p>
    </div>
    <div class="flex items-center">
      <mg-icon [iconName]="currentInterval.iconName"
        [iconClass]="isIntervalDisabled ? 'text-gray-500 text-4xl' : 'text-mg-green-dark text-4xl'">
      </mg-icon>
    </div>
  </div>
  <div class="relative">
    <button
      class="flex border rounded-full px-2 py-2 items-center justify-evenly text-md gap-1 font-semibold cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      [ngClass]="{
        'bg-mg-red-dark border-mg-red-dark text-white': redButtonExist,
        'bg-transparent border-mg-main-blue-dark text-mg-main-blue-dark': !redButtonExist
      }" [disabled]="isLoadingExtemp" (click)="onLastMarkClick()">
      <mg-icon [iconName]="ExtemporaniousMark()"></mg-icon>
        @if (currentDate !== '--:--') {
          <span
          class="font-semibold ml-1" [ngClass]="redButtonExist ? 'text-white' : 'text-mg-main-blue-dark'"
          >Últ. marca</span>
        }
      <p class="flex mx-1">{{ currentDate }}</p>
    </button>
  </div>
</div>
}